import { useMemo } from 'react';
import { UserPlus, FileCheck2, FileSpreadsheet, Zap, ArrowRightLeft, Users, LayoutList } from 'lucide-react';

export const useSourceDetails = (sources) => {
  const itemsWithName = useMemo(
    () =>
      new Set([
        'browser_extension_single_contact_import',
        'admin_portal_single_contact_import',
        'csv_import',
        'shared',
        'job_board',
      ]),
    [],
  );
  const items = useMemo(
    () => [
      {
        id: 1,
        title: 'Added manually by',
        sources: new Set(['browser_extension_single_contact_import', 'admin_portal_single_contact_import']),
        icon: UserPlus,
      },
      {
        id: 2,
        title: 'Applied to a job',
        sources: new Set(['job_application']),
        icon: FileCheck2,
      },
      {
        id: 3,
        title: 'Imported via CSV by',
        sources: new Set(['csv_import']),
        icon: FileSpreadsheet,
      },
      {
        id: 3,
        title: 'Job Board',
        sources: new Set(['job_board']),
        icon: LayoutList,
      },
      {
        id: 4,
        title: 'Joined Talent Network',
        sources: new Set(['tn_onboarding']),
        icon: Users,
      },
      {
        id: 5,
        title: 'Shared by',
        sources: new Set(['shared']),
        icon: ArrowRightLeft,
      },
      {
        id: 6,
        title: 'Synced from Integration / API',
        sources: new Set(['client_api_bulk_import']),
        icon: Zap,
      },
    ],
    [],
  );

  // get all source that sourceDetails has
  const sourcesToRender = useMemo(
    () =>
      sources
        .map(({ source, user, addedOn }) => {
          const item = items.find((s) => s.sources.has(source));

          if (!item) {
            return null;
          }

          if (itemsWithName.has(source)) {
            return { ...item, title: `${item.title} ${user?.name ?? ''}`, addedOn };
          }

          return { ...item, addedOn };
        })
        .filter(Boolean)
        .sort((a, b) => new Date(b.addedOn) - new Date(a.addedOn)),
    [sources, items, itemsWithName],
  );

  return sourcesToRender;
};
